function scrollToFirstError () {
	const errorEl = document.querySelector('.input-error')
	if (!errorEl) return
	if (typeof errorEl.scrollIntoView !== 'function') return

	errorEl.scrollIntoView({
		behavior: 'smooth',
		block: 'center'
	})
}

scrollToFirstError()
